import WResultsNutrition from './WResultsNutrition'

export default WResultsNutrition
